import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import {
    Grid,
    TextField,
    Button,
    Box,
    Typography,
} from '@mui/material';
import Routes from '../../../routes';
import { toastResponseError } from '../../../utils';
import { trakrefBlue, trakrefDisabledBlue } from '../../../color_utils';
import Select from "../../Common/Select";
import Input from '../../Common/InputField';

import CommonModal from '../../Common/CommonModal';
import DeleteIcon from "../../../Icons/Delete_Icon.svg"

const DeleteWorkOrderModal = ({ payload, modalOpen, onClose, refreshRequired }) => {
    const fileInput = useRef();
    const [laborCost, setLaborCost] = useState(null);
    const [otherCost, setOtherCost] = useState(null);
    const [materialCost, setMaterialCost] = useState(null);


    var ConfirmDeleteWorkOrder = async () => {


        const postConfig = {
            method: "POST",
            headers: { 'Content-Type': 'application/json' },
        }


        const UpdateResponse = await fetch(Routes.WorkOrder.DeleteWorkOrder(payload.ID), postConfig)
        console.log(UpdateResponse)
        if (UpdateResponse.status == 200) {
            onClose()
            refreshRequired()
        } else {
            // AB#17142: a forbidden or failed delete used to fail silently
            await toastResponseError(UpdateResponse, 'Failed to delete the work order.');
        }

    }

    return (
        <CommonModal open={modalOpen} close={onClose}>
            <Grid container sx={{ px: { xs: 1, sm: 10 } }}>
                <Grid item xs={12} lg={12} mb={1} pt={2} align='center'>
                    <img src={DeleteIcon}/>
                </Grid>
                <Grid item xs={12} lg={12} mb={2} pt={2} align='center'>
                    <Typography sx={{ padding: '1% 0%', fontSize: 22, fontWeight: 700 }}>
                        Delete Work Order #{payload.ID}?
                    </Typography>
                </Grid>
                <Grid item xs={12} lg={12} mb={2} pt={2} align='center'>
                    <Typography sx={{ padding: '1% 0%', fontSize: 16, fontWeight: 200 }}>
                        Once deleted, this work order will no longer be available to perform work on. 
                    </Typography>
                </Grid>
                <Grid item xs={12} lg={12} align='center'>
                    <Box mt={2} mb={2} sx={{ width: '100%' }}>
                        <Button
                            fullWidth
                            size='large'
                            variant='contained'
                            onClick={() => ConfirmDeleteWorkOrder()}
                            style={{
                                backgroundColor: trakrefBlue
                            }}
                        >
                            <Typography sx={{ padding: '1% 0%', color: '#fff', fontSize: 17, fontWeight: 400 }}>
                                DELETE WORK ORDER
                            </Typography>
                        </Button>
                    </Box>
                </Grid>

            </Grid>
        </CommonModal>
    );
};

//ReOpenModal.propTypes = {
//    id: PropTypes.string.isRequired,
//    open: PropTypes.bool.isRequired,
//    closeModal: PropTypes.func.isRequired,
//    setDataRefresh: PropTypes.func.isRequired,
//};

export default DeleteWorkOrderModal;
